import { render, staticRenderFns } from "./SuperInput.vue?vue&type=template&id=20483b67&scoped=true&"
import script from "./SuperInput.vue?vue&type=script&lang=js&"
export * from "./SuperInput.vue?vue&type=script&lang=js&"
import style0 from "./SuperInput.vue?vue&type=style&index=0&id=20483b67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20483b67",
  null
  
)

export default component.exports